
  export default {
    layout: 'default',
    data(){
      return {
      }
    },
    created() {
      this.$router.push({ name: 'browse' })
    },
  }
